exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".WaysToSync{margin:0 auto;width:482px}@media only screen and (max-width: 620px){.WaysToSync{width:288px}}.WaysToSync-header{font-size:24px;font-weight:500;margin-bottom:4px}.WaysToSync-subheader{font-weight:400;margin-bottom:48px}", ""]);

// exports
